import { cn } from '@/core/utils/cn';

interface TableProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export function Table({ children, className, id }: TableProps) {
  return (
    <div className="overflow-x-auto">
      <table id={id} className={cn('w-full', className)}>{children}</table>
    </div>
  );
}

export function TableHeader({ children, className, id }: TableProps) {
  return <thead id={id} className={cn('', className)}>{children}</thead>;
}

export function TableBody({ children, className, id }: TableProps) {
  return <tbody id={id} className={cn('', className)}>{children}</tbody>;
}

export function TableRow({ children, className, id }: TableProps & { onClick?: () => void }) {
  return (
    <tr id={id} className={cn('border-b border-hms-border/50 hover:bg-white/[0.02] transition-colors', className)}>
      {children}
    </tr>
  );
}

export function TableHead({ children, className }: TableProps) {
  return (
    <th className={cn('text-left text-[11px] font-semibold text-hms-textDim uppercase tracking-wider px-4 py-3 bg-hms-bg/50', className)}>
      {children}
    </th>
  );
}

export function TableCell({ children, className }: TableProps) {
  return (
    <td className={cn('text-[13px] text-hms-textSub px-4 py-3', className)}>
      {children}
    </td>
  );
}
